"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpressionDetailsSchema = exports.ExpressionVariableSchema = void 0;
exports.convertVariablesRecordToArray = convertVariablesRecordToArray;
const zod_1 = require("zod");
const AbsoluteCharacteristicValueBase_1 = require("../../CircuitStates/AbsoluteCharacteristicValueBase");
const BoundaryCharacteristic_1 = require("../../BoundaryCharacteristic");
exports.ExpressionVariableSchema = zod_1.z.object({
    variablename: zod_1.z.string(),
    originalName: zod_1.z.string().optional(),
    value: AbsoluteCharacteristicValueBase_1.AbsoluteCharacteristicValueBaseSchema,
});
exports.ExpressionDetailsSchema = zod_1.z.object({
    expression: zod_1.z.string(),
    evaluatedValue: AbsoluteCharacteristicValueBase_1.AbsoluteCharacteristicValueBaseSchema.nullable(),
    variables: zod_1.z.array(exports.ExpressionVariableSchema).nullable(),
    characteristic: BoundaryCharacteristic_1.BoundaryCharacteristicSchema,
});
function convertVariablesRecordToArray(variables, expressionVariables) {
    if (!variables) {
        return null;
    }
    return Object.entries(variables).map(([variablename, value]) => {
        const expressionVar = expressionVariables?.find((v) => v.id === variablename);
        return {
            variablename,
            originalName: expressionVar?.originalName,
            value,
        };
    });
}
//# sourceMappingURL=ExpressionVariableValues.js.map